module.exports = __webpack_public_path__ + "img/icon_logo.5979927d.png";